<template>
	<div id="roleTips" v-loading="roleLoading">
		<div class="title">
			<el-row>
				<el-col :span="6" style="padding-left:35px">
					<el-checkbox v-model="selectAll" @change="roleListChange($event,'1')">全部</el-checkbox>
				</el-col>
				<el-col :span="3"><el-checkbox v-model="checkEdit" @change="selectCheckAll($event,'update')">编辑</el-checkbox></el-col>
				<el-col :span="3"><el-checkbox v-model="checkWatch" @change="selectCheckAll($event,'query')">查看</el-checkbox></el-col>
				<el-col :span="3"><el-checkbox v-model="checkInput" @change="selectCheckAll($event,'print')">打印</el-checkbox></el-col>
				<el-col :span="3"><el-checkbox v-model="checkOutput" @change="selectCheckAll($event,'export')">导出</el-checkbox></el-col>
				<el-col :span="6"><el-checkbox v-model="checkQt" @change="selectCheckAll($event,'others')">其他</el-checkbox></el-col>
			</el-row>
		</div>
		<div class="content">
			<el-scrollbar class="default-scrollbar">
				<div v-for="(item,index) in treeDatas" :key="index"  class="prentRole">
					<el-row>
						<el-col :span="6">
							<div class="icon" @click="roleMenu(item)">
								<i class="el-icon-caret-bottom" v-show="item.show" v-if="item.children && item.children.length >0"></i>
								<i class="el-icon-caret-right" v-show="!item.show" v-if="item.children && item.children.length >0"></i>
							</div>
							<el-checkbox v-model="item.checked" @change="selectChild($event,item,'checked')">{{item.name}}</el-checkbox>
						</el-col>
						<el-col :span="3">
							<el-checkbox v-if="getRoleShow(item,'update')" v-model="item.update" @change="selectChild($event,item,'update')"></el-checkbox>
						</el-col>
						<el-col :span="3">
							<el-checkbox v-if="getRoleShow(item,'query')" v-model="item.query" @change="selectChild($event,item,'query')"></el-checkbox>
						</el-col>
						<el-col :span="3">
							<el-checkbox v-if="getRoleShow(item,'print')" v-model="item.print" @change="selectChild($event,item,'print')"></el-checkbox>
						</el-col>
						<el-col :span="3">
							<el-checkbox v-if="getRoleShow(item,'export')" v-model="item.export" @change="selectChild($event,item,'export')"></el-checkbox>
						</el-col>
						<el-col :span="6" v-if="item.children && item.children.length >0">
							<el-checkbox v-if="getRoleShow(item,'others')" v-model="item.others" @change="selectChild($event,item,'others')"></el-checkbox>
						</el-col>
					</el-row>
					<el-collapse-transition>
						<div v-show="item.show">
							<div class="childRole" v-if="item.children && item.children.length >0" v-for="(items,index) in item.children" :key="index">
								<el-row>
									<el-col :span="6" style="padding-left:50px">
										<el-checkbox v-model="items.checked" @change="selectChildren($event,items,'checked')">{{items.name}}</el-checkbox>
									</el-col>
									<el-col :span="3">
										<div class="funcRole" v-if="items.update && items.update.length >0">
											<el-checkbox v-model="itemd.checked" v-for="(itemd,index) in items.update" :key="index" :label="itemd.id">{{itemd.name}}</el-checkbox>
										</div>
									</el-col>
									<el-col :span="3">
										<div class="funcRole" v-if="items.query && items.query.length >0">
											<el-checkbox @change="changeQuerys($event,items)" v-model="itemd.checked" v-for="(itemd,index) in items.query" :key="index" :label="itemd.id">{{itemd.name}}</el-checkbox>
										</div>
									</el-col>
									<el-col :span="3">
										<div class="funcRole" v-if="items.print && items.print.length >0">
											<el-checkbox v-model="itemd.checked" v-for="(itemd,index) in items.print" :key="index" :label="itemd.id">{{itemd.name}}</el-checkbox>
										</div>
									</el-col>
									<el-col :span="3">
										<div class="funcRole" v-if="items.export && items.export.length >0">
											<el-checkbox v-model="itemd.checked" v-for="(itemd,index) in items.export" :key="index" :label="itemd.id">{{itemd.name}}</el-checkbox>
										</div>
									</el-col>
									<el-col :span="6">
										<div class="funcRole" v-if="items.others && items.others.length >0">
											<el-checkbox v-model="itemd.checked" v-for="(itemd,index) in items.others" :key="index" :label="itemd.id">{{itemd.name}}</el-checkbox>
										</div>
									</el-col>
								</el-row>
							</div>
						</div>
					</el-collapse-transition>
				</div>
			</el-scrollbar>
		</div>
		<el-button class='fr treeButton minButton'  size='mini' @click='saveTree'>保存</el-button>
	</div>
</template>

<script>
	export default{
		props:['roleId','roleInputValue','oldName'],
		data(){
			return {
				roleLoading:false,
				
				treeDatas:[],
				roles:[],
				ids:[],
				
				selectAll:false,
				checkEdit:false,
				checkWatch:false,
				checkInput:false,
				checkOutput:false,
				checkQt:false,
			}
		},
		methods:{
			init(){
				// 获取菜单树
				this.roleLoading = true;
				this.$http.post('sys/menu/findTree',{roleId: this.roleId}).then(res=>{
					this.roleLoading = false;
					if(res && res.data.code == '1') {
						let list = res.data.data;
						//判断全选功能
						for(let i=0;i<list.length;i++){
							list[i].export = false;
							list[i].others = false;
							list[i].print = false;
							list[i].query = false;
							list[i].update = false;
						};
						this.treeDatas = this.forEachs(list);
					}
				}).catch(e=>{
					this.roleLoading = false;
				});
			},
			forEachs(list){
				for(let i=0;i<list.length;i++){
					list[i].show = true;
					if(list[i].children && list[i].children.length > 0){
						this.forEachs(list[i].children);
					}
				};
				return list;
			},//设置子元素的选择
			setChildSelecet(list,bol){
				list.forEach(item=>{
					item.checked = bol;
					if(Array.isArray(item.export)){
						item.export.forEach(item=>{
							item.checked = bol;
						})
					}else{
						item.export = bol;
					};
					if(Array.isArray(item.others)){
						item.others.forEach(item=>{
							item.checked = bol;
						})
					}else{
						item.others = bol;
					};
					if(Array.isArray(item.print)){
						item.print.forEach(item=>{
							item.checked = bol;
						})
					}else{
						item.print = bol;
					};
					if(Array.isArray(item.query)){
						item.query.forEach(item=>{
							item.checked = bol;
						})
					}else{
						item.query = bol;
					};
					if(Array.isArray(item.update)){
						item.update.forEach(item=>{
							item.checked = bol;
						})
					}else{
						item.update = bol;
					};
				
					if(item.children && item.children.length >0){
						this.setChildSelecet(item.children,bol);
					}
				});
			},//checkBox change 事件
			roleListChange(val,key){
				const _=this;
				_.checkEdit=val;_.checkWatch=val;_.checkInput=val;
				_.checkOutput=val;_.checkQt=val;
				_.setChildSelecet(_.treeDatas,val);
			},//全选操作
			selectCheckAll(bol,key){
				const _=this;
				if(bol && key != 'query'){//当其中的任一一个有权限是 必须有查看权限
					_.checkWatch = bol;
					_.setCheckBoxVal(_.treeDatas,bol,'query');
				};
				if(!bol && key == 'query'){//当没有查看权限时 其他的 编辑 导出 等都不能有权限
					_.checkEdit = bol;
					_.checkInput = bol;
					_.checkOutput = bol;
					_.checkQt = bol;
					_.setCheckBoxVal(_.treeDatas,bol,'update');
					_.setCheckBoxVal(_.treeDatas,bol,'print');
					_.setCheckBoxVal(_.treeDatas,bol,'export');
					_.setCheckBoxVal(_.treeDatas,bol,'others');
				}
				_.setCheckBoxVal(_.treeDatas,bol,key);
			},//设置全选状态值
			setCheckBoxVal(list,bol,key){
				const _=this;
				list.forEach(item=>{
					if(!bol && key=="query"){
						_.changeQuerys(bol,item);
					};
					
					if(Array.isArray(item[key])){
						item[key].forEach(item=>{
							item.checked = bol;
						})
					}else{
						item[key] = bol;
					};
					if(item.children && item.children.length>0){
						_.setCheckBoxVal(item.children,bol,key);
					}
				});
			},//第一级菜单 当它下面的都没有时则不展示
			getRoleShow(item,key){
				const _=this;
				let bol = true;
				if(item.children && item.children.length <= 0){
					bol = false;
				}else if(item.children && item.children.length > 0){
					let num = 0;
					item.children.forEach(item=>{
						num += item[key].length; 
					});
					if(num <= 0){
						bol = false;
					}
				};
				return bol;
			},//全选子元素
			selectChild(bol,item,key){
				const _=this;
				if(item.children && item.children.length>0){
					item.children.forEach(items=>{
						if(key == 'checked'){
							items.checked = bol;
							items.update.forEach(it=>{it.checked =bol;});
							items.query.forEach(it=>{it.checked =bol;});
							items.others.forEach(it=>{it.checked =bol;});
							items.print.forEach(it=>{it.checked =bol;});
							items.export.forEach(it=>{it.checked =bol;});
							items.others.forEach(it=>{it.checked =bol;});
						}else{
							items[key].forEach(it=>{it.checked =bol;});
						}
						if(!bol && key=="query"){
							_.changeQuerys(bol,items);
						}
					});
				};
			},
			selectChildren(bol,item,key){
				const _=this;
				if(item.update && item.update.length>0){
					item.update.forEach(items=>{
						items.checked = bol;
					});
				};
				if(item.query && item.query.length>0){
					item.query.forEach(items=>{
						items.checked = bol;
					});
				};
				if(item.print && item.print.length>0){
					item.print.forEach(items=>{
						items.checked = bol;
					});
				};
				if(item.export && item.export.length>0){
					item.export.forEach(items=>{
						items.checked = bol;
					});
				};
				if(item.others && item.others.length>0){
					item.others.forEach(items=>{
						items.checked = bol;
					});
				};
			},//query 如果当前条没有查看权限 则也没有其他的权限
			changeQuerys(bol,item){
				const _=this;
				if(!bol){
					item.checked = bol;
					if(item.update && item.update.length>0){
						item.update.forEach(items=>{
							items.checked = bol;
						});
					};
					if(item.print && item.print.length>0){
						item.print.forEach(items=>{
							items.checked = bol;
						});
					};
					if(item.export && item.export.length>0){
						item.export.forEach(items=>{
							items.checked = bol;
						});
					};
					if(item.others && item.others.length>0){
						item.others.forEach(items=>{
							items.checked = bol;
						});
					};
				}
			},
			//check 展开关闭
			roleMenu(val){
				const _=this;
				val.show = !val.show;
			},
			saveTree(){
				const _=this;

				_.ids.splice(0);
				let datas = JSON.parse(JSON.stringify(_.treeDatas));
				_.getIAnthoIds(datas);
				if(_.roleInputValue==="") {
					return _.$message.warning('角色名字不能为空!')
				}
				//
				if(_.ids.length<=0) {
					return _.$message.warning('角色权限不能为空!')
				}

				_.roleLoading = true;
				_.$http.post('sys/menu/saveRole',{
					roleId:_.roleId,
					menuIds:_.ids,
					name: _.roleInputValue,
					oldName: _.oldName
				}).then(res=>{
					this.roleLoading = false;
					if(res && res.data.code == '1'){
						_.$message.success('保存成功！');
						_.$emit('on_success',true);
					}
				}).catch(res=>{
					this.roleLoading = false;
				})
			},//获取被选择的Ids
			getIAnthoIds(list){
				const _=this;
				list.forEach(item=>{
					if(item.checked){
						_.ids.push(item.id);
					};
					if(item.children && item.children.length >0){
						item.children.forEach(itemd=>{
							if(itemd.checked){
								_.ids.push(itemd.id);
							};
							
							itemd.update.forEach(e1=>{
								if(e1.checked){
									_.ids.push(e1.id);
								}
							});
							itemd.query.forEach(e2=>{
								if(e2.checked){
									_.ids.push(e2.id);
								}
							});
							itemd.print.forEach(e3=>{
								if(e3.checked){
									_.ids.push(e3.id);
								}
							});
							itemd.export.forEach(e4=>{
								if(e4.checked){
									_.ids.push(e4.id);
								}
							});
							itemd.others.forEach(e5=>{
								if(e5.checked){
									_.ids.push(e5.id);
								}
							});
						});
					}
				});
			}
		},
		mounted(){
			console.log('角色id：',this.roleId);
			this.init();
		},
		created(){
			
		},
		watch:{
			roleId(val){
				this.init();
			},
			treeDatas:{
				handler(Val){
					const _=this;
					let check = 0;let e1 = 0;let e2 = 0;let e3 = 0;let e4 = 0;let e5 = 0;
					Val.forEach(item=>{
						if(item.checked){check ++;};
						if(item.update){e1++;};	//编辑
						if(item.query){e2++;};	//查看
						if(item.print){e3++;};	//打印
						if(item.export){e4++;};	//打印
						if(item.others){e5++;};	//其他
						
						if(item.children && item.children.length > 0){
							let nums = 0;let a1=0;let a2=0;let a3=0;let a4=0;let a5=0;
							item.children.forEach(items=>{
								let count = 0;let len = 0;let cos = 0;
								if(items.checked){
									nums++;
								};
								len +=items.update.length;
								if(items.update && items.update.length >0){
									items.update.forEach(itemd=>{
										if(itemd.checked){a1++;count++;cos++;}
									});
								};
								len +=items.query.length;
								if(items.query && items.query.length >0){
									items.query.forEach(itemd=>{
										if(itemd.checked){a2++;count++;};
									});
								};
								len +=items.print.length;
								if(items.print && items.print.length >0){
									items.print.forEach(itemd=>{
										if(itemd.checked){a3++;count++;cos++;}
									});
								};
								len +=items.export.length;
								if(items.export && items.export.length >0){
									items.export.forEach(itemd=>{
										if(itemd.checked){a4++;count++;cos++;}
									});
								};
								len +=items.others.length;
								if(items.others && items.others.length >0){
									items.others.forEach(itemd=>{
										if(itemd.checked){a5++;count++;cos++;}
									});
								};
								if( len != 0){
									if(count >0){items.checked = true;}else{}
								};
								if(cos>0){
									if(items.query.length>0){
										items.query[0].checked = true;
									}
								}
							});
							if(nums > 0){item.checked = true;}else{item.checked = false;}
							
							if(a1 > 0){item.update = true;}else{item.update = false;}
							if(a2 > 0){item.query = true;}else{item.query = false;}
							if(a3 > 0){item.print = true;}else{item.print = false;}
							if(a4 > 0){item.export = true;}else{item.export = false;}
							if(a5 > 0){item.others = true;}else{item.others = false;}
						}
					});
					if(check > 0){_.selectAll = true;}else{_.selectAll = false;};
					if(e1 > 0){_.checkEdit = true;}else{_.checkEdit = false;}
					if(e2 > 0){_.checkWatch = true;}else{_.checkWatch = false;}
					if(e3 > 0){_.checkInput = true;}else{_.checkInput = false;}
					if(e4 > 0){_.checkOutput = true;}else{_.checkOutput = false;}
					if(e5 > 0){_.checkQt = true;}else{_.checkQt = false;}
				},
				deep:true
			}
			
		}
	}
</script>

<style scoped lang="less">
	#roleTips{
		.icon{
			display: inline-block;
			width: 12px;height: 12px;
			margin-right: 5px;
			i{
				text-align: center;
				line-height: 12px;
				border: 1px solid #DCDFE6;
				cursor: pointer;
			}
		}
		.title{
			.el-row{
				background-color: #EEE;
			}
		}
		.el-row{
			border:1px solid #D8DCE5;
			border-bottom: none;
			.el-col{
				display: table-cell;
				border-right:1px solid #D8DCE5;
				padding:5px 0 5px 15px;
			}
			
		}
		.prentRole{
			&>.el-row{
				display: flex;
				background-color: #f6f6f6;
			}
			&>.childRole:last-child{
				.el-row{
					border-bottom:1px solid #D8DCE5;
				}
			}
		}
		.childRole{
			&>.el-row{
				display: flex;
				border-bottom: dashed 1px #D8DCE5;
				border-top: dashed 1px #D8DCE5;
				.el-col{
					border-right: dashed 1px #D8DCE5;
					&>.el-col:last-child{
						border-bottom:none;
					}
				}
			}
		}
		.funcRole{
			.el-checkbox{display: block}
		}
		.content{
			height:490px;
			overflow: hidden;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/dialog/roleList.vue